import './VectorEditor.scss';
import { Vector3 } from 'three';
import { defineComponent, h, PropType } from 'vue';

export default defineComponent({
    props: {
        value: {
            required: true,
            type: Object as PropType<Vector3>,
        },

        readonly: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    emits: {
        'update:value': (x: Vector3) => true,
    },

    render() {
        return h('div', { class: 'vector-editor' }, [
            h('input', {
                type: 'number',
                class: 'form-control',
                readonly: this.readonly,
                autocomplete: 'off',
                value: this.value.x,
                onInput: this.readonly
                    ? () => false
                    : (e: Event) => this.$emit('update:value', new Vector3(
                        (e.target as HTMLInputElement).valueAsNumber,
                        this.value.y,
                        this.value.z,
                    )),
            }),
            h('input', {
                type: 'number',
                class: 'form-control',
                readonly: this.readonly,
                autocomplete: 'off',
                value: this.value.y,
                onInput: this.readonly
                    ? () => false
                    : (e: Event) => this.$emit('update:value', new Vector3(
                        this.value.x,
                        (e.target as HTMLInputElement).valueAsNumber,
                        this.value.z,
                    )),
            }),
            h('input', {
                type: 'number',
                class: 'form-control',
                readonly: this.readonly,
                autocomplete: 'off',
                value: this.value.z,
                onInput: this.readonly
                    ? () => false
                    : (e: Event) => this.$emit('update:value', new Vector3(
                        this.value.x,
                        this.value.y,
                        (e.target as HTMLInputElement).valueAsNumber,
                    )),
            }),
        ]);
    },
});
